import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { CloseButton, PrimaryButton } from './Buttons';
import { toast } from 'react-toastify';
import CustomInput from './CustomInput';

const SSPPassphraseModal = ({ isOpen, onClose, onConfirm, loading = false }) => {
    const [passphrase, setPassphrase] = useState('');
    const [showPassphrase, setShowPassphrase] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!passphrase.trim()) {
            setError('Please enter the SSL passphrase');
            return;
        }

        try {
            await onConfirm(passphrase);
            // Reset form on success
            setPassphrase('');
            setError('');
        } catch (err) {
            // Handle specific SSL passphrase error
            if (err.response?.status === 402 && err.response?.data?.detail === "Invalid passphrase for private key") {
                const errorMessage = 'Invalid passphrase for private key. Please check your SSL passphrase and try again.';
                setError(errorMessage);
                toast.error(errorMessage);
            } else {
                const errorMessage = err.response?.data?.detail || err.message || 'Invalid passphrase';
                setError(errorMessage);
                toast.error(errorMessage);
            }
        }
    };

    const handleClose = () => {
        setPassphrase('');
        setError('');
        setShowPassphrase(false);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1001]">
            <div className="bg-white rounded-xl w-full max-w-md mx-4">
                <div className="p-6 border-b border-gray-200 flex justify-between items-center">
                    <h3 className="text-xl font-semibold text-gray-800">SSL Authentication</h3>
                    <CloseButton onClick={handleClose} />
                </div>
                
                <div className="p-6">
                    <div className="mb-4">
                        <p className="text-gray-600 mb-4 text-sm">
                            Please enter your SSL passphrase to proceed with generating the receipt.
                        </p>
                        
                        <form onSubmit={handleSubmit}>
                            <div className="mb-4">
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    SSL Passphrase
                                </label>
                                <div className="relative">
                                    <CustomInput
                                        type={showPassphrase ? "text" : "password"}
                                        value={passphrase}
                                        onChange={(e) => setPassphrase(e.target.value)}
                                        placeholder="Enter SSL passphrase"
                                       
                                        disabled={loading}
                                    />
                                    <button
                                        type="button"
                                        className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                                        onClick={() => setShowPassphrase(!showPassphrase)}
                                        disabled={loading}
                                    >
                                        {showPassphrase ? <EyeOff size={16} /> : <Eye size={16} />}
                                    </button>
                                </div>
                                {error && (
                                    <p className="text-red-600 text-sm mt-1">{error}</p>
                                )}
                            </div>
                            
                            <div className="flex justify-end gap-3">
                              
                                <PrimaryButton
                                    type="submit"
                                    disabled={loading || !passphrase.trim()}
                                    className="px-4 py-2"
                                >
                                    {loading ? (
                                        <div className="flex items-center gap-2">
                                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                                            Verifying...
                                        </div>
                                    ) : (
                                        'Verify & Send'
                                    )}
                                </PrimaryButton>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SSPPassphraseModal; 